import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onedayschoolpicnic() {



    const cardData =
    {
        keyword: 'One-day School Picnic Near Morachi Chincholi Pune',
        heading: 'Anand Krushi Paryatan Kendra: One-day School Picnic Near Morachi Chincholi Pune',
        headingDescription: 'Planning a fun and educational one-day school picnic near Morachi Chincholi Pune? Anand Krushi Paryatan Kendra, located just 55 km from Pune, offers the perfect destination for students to enjoy nature, learn about rural life, and participate in engaging outdoor activities—all within a safe and eco-friendly environment. Spread across 40 acres, this agri-tourism center provides a full-day experience packed with excitement and learning. Students can enjoy bullock cart and tractor rides, horse riding, boating, swimming, and a rain dance session. Cultural highlights like puppet shows, magic shows, and traditional village games add to the joy and learning experience.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

topPlaces: [
  {
    "title": "Tractor Safari Through Farmlands",
    "description": "Kickstart the school picnic with a colorful tractor ride across lush fields and flower patches. Students enjoy the bumpy ride, learn about different crops, and spot peacocks or birds along the way—a perfect rural welcome."
  },
  {
    "title": "Agro-Farming Demonstration",
    "description": "Children are introduced to organic farming by sowing seeds, watering plants, and seeing traditional tools in action. A fun, hands-on way to learn where their food comes from and how nature works."
  },
  {
    "title": "Healthy Farm Breakfast",
    "description": "Enjoy a nutritious, rural-style breakfast with poha, upma, or sabudana khichdi served fresh from the chulha. Kids sit together under shady trees or pavilions, soaking in fresh air and warm hospitality."
  },
  {
    "title": "Bullock Cart Ride Fun",
    "description": "Groups of students hop on bullock carts for a slow, joyful ride through village tracks. It's safe, exciting, and gives a glimpse of how transport worked before vehicles took over."
  },
  {
    "title": "Outdoor Games & Play Zone",
    "description": "From sack races and tug-of-war to kho-kho, lagori, and gilli danda—children enjoy free-play time in wide open grounds. Swings, rope bridges, and bamboo slides add to the fun."
  },
  {
    "title": "Animal Petting Farm",
    "description": "Students interact with goats, hens, cows, ducks, and even friendly calves. Supervised animal encounters teach care, compassion, and curiosity about rural life and its creatures."
  },
  {
    "title": "Eco-Friendly Craft Workshop",
    "description": "Kids enjoy simple, guided workshops in clay pottery, diya painting, or weaving. They create and take home their handmade souvenirs while learning about local arts and crafts."
  },
  {
    "title": "Farm-Fresh Maharashtrian Lunch",
    "description": "A delicious vegetarian thali is served on banana leaves featuring pithla, bhakri, dal, rice, and sweet treats. Meals are nutritious, tasty, and a great way to introduce local cuisine to young minds."
  },
  {
    "title": "Rain Dance & Water Fun (Optional)",
    "description": "If included in the package, children can enjoy a supervised rain dance with upbeat music and splash zones—ideal for summer visits and special treat days."
  },
  {
    "title": "Group Photo & Return Gifts",
    "description": "Before heading back, group photos are clicked under trees or with decorated carts. Kids receive small rural-themed souvenirs like clay toys or seed kits to remember the day."
  }
],




"services": [
  {
    "name": "Educational Picnic Near Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra offers the perfect setting for educational picnics that blend fun with learning. Surrounded by nature and rural life, students get hands-on exposure to farming, eco-practices, and village culture while enjoying outdoor games and guided tours."
  },
  {
    "name": "Safe School Picnic Locations Near Pune",
    "description": "Safety is our priority. We offer a secure, well-monitored environment with shaded picnic zones, separate play areas for different age groups, first-aid availability, and staff supervision to ensure a smooth and safe outing for school children."
  },
  {
    "name": "Fun Learning Farm Activities for Students",
    "description": "Students participate in interactive farm-based tasks such as planting, composting, vegetable identification, and seasonal farming demos. These hands-on experiences make textbook lessons come alive in a fun, engaging way."
  },
  {
    "name": "Nature-Based School Outings",
    "description": "Our farm is a living classroom. With nature trails, observation points, and tree-identification walks, students explore flora, fauna, and sustainable living concepts while breathing in fresh rural air."
  },
  {
    "name": "Bird Watching Tours for Kids",
    "description": "Located near the famous peafowl region of Morachi Chincholi, our center offers exciting bird-watching tours led by guides. Kids learn to observe and identify species like peacocks, kingfishers, and more using child-friendly birding materials."
  },
  {
    "name": "Agro-Tourism Picnic for Schools",
    "description": "Introduce your students to the basics of agriculture through guided farm tours, equipment demonstrations, and seed-to-harvest storytelling. It's a great way to connect them with India's rural roots and food cycle awareness."
  },
  {
    "name": "Cultural Learning Trips for Students",
    "description": "From traditional folk performances to bullock cart rides, students get a taste of Maharashtrian village life. Activities are designed to promote cultural understanding, respect for traditions, and appreciation for rural simplicity."
  },
  {
    "name": "Farm Games for Children",
    "description": "Fun is part of the learning process! Students enjoy outdoor games like sack races, tug-of-war, treasure hunts, and group activities—all in a safe and supervised farm environment tailored for kids."
  },
  {
    "name": "Interactive Workshops for School Groups",
    "description": "We organize age-appropriate workshops on composting, organic farming, pottery, and rural crafts. These hands-on sessions help students build curiosity, creativity, and eco-awareness in a fun, practical way."
  },
  {
    "name": "School Picnic with Lunch Facility",
    "description": "Wholesome, hygienic Maharashtrian meals are served in clean dining areas. Special menus are available for students, with fresh farm-to-table ingredients and optional meal customization for dietary needs."
  },
  {
    "name": "Outdoor Team-Building for Students",
    "description": "Foster teamwork and communication among students with group tasks like farm relays, problem-solving challenges, and nature-inspired obstacle courses—all designed to encourage collaboration and leadership."
  },
  {
    "name": "Guided Nature Walks for Schools",
    "description": "Educators and nature experts lead students on guided walks, explaining local ecology, flora, and wildlife in simple, engaging language. Ideal for environmental science and nature appreciation learning."
  },
  {
    "name": "Eco-Friendly Picnic Ideas for Schools",
    "description": "We promote green practices like no plastic use, natural serving materials, and environmental learning. Students also engage in eco-tasks like tree planting or seed bomb creation, reinforcing sustainability."
  },
  {
    "name": "Budget School Trips Near Pune",
    "description": "Our packages are priced affordably for government and private schools alike. With inclusive options covering entry, lunch, workshops, and activities, we make experiential learning accessible and value-driven."
  },
  {
    "name": "One-Day School Field Trip Locations",
    "description": "Located conveniently near Pune and Morachi Chincholi, our center is ideal for one-day field trips. With ample parking, sanitation facilities, and organized scheduling, schools can plan hassle-free educational outings."
  }
],
"tableData": [
  ["Educational Picnic Near Morachi Chincholi", "- Safe School Picnic Locations Near Pune"],
  ["Fun Learning Farm Activities for Students", "- Nature-Based School Outings"],
  ["Bird Watching Tours for Kids", "- Agro-Tourism Picnic for Schools"],
  ["Cultural Learning Trips for Students", "- Farm Games for Children"],
  ["Interactive Workshops for School Groups", "- School Picnic with Lunch Facility"],
  ["Outdoor Team-Building for Students", "- Guided Nature Walks for Schools"],
  ["Eco-Friendly Picnic Ideas for Schools", "- Budget School Trips Near Pune"],
  ["One-Day School Field Trip Locations", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Educational and Fun Outdoor Learning",
    "WhyChoosedescription": "Morachi Chincholi offers a unique combination of nature and agriculture where students can learn about peacocks, local flora and fauna, and sustainable farming practices, making it an enriching outdoor classroom experience."
  },
  {
    "WhyChooseheading": "Engaging Farm Activities",
    "WhyChoosedescription": "Students can participate in interactive activities such as bullock cart rides, tractor tours, animal feeding, and fruit picking, allowing hands-on learning about rural life and farming traditions."
  },
  {
    "WhyChooseheading": "Safe and Spacious Picnic Spots",
    "WhyChoosedescription": "The agro-tourism centers near Morachi Chincholi provide secure and large open areas perfect for children to play, run, and enjoy group games, ensuring a fun and safe environment for school outings."
  },
  {
    "WhyChooseheading": "Cultural Programs and Folk Entertainment",
    "WhyChoosedescription": "Schools can enjoy folk music, puppet shows, and traditional games that introduce children to Maharashtrian rural culture, making the picnic both educational and entertaining."
  },
  {
    "WhyChooseheading": "Affordable Group Packages",
    "WhyChoosedescription": "Specially designed school picnic packages include meals, transportation options, guided tours, and activities at budget-friendly rates, helping schools organize hassle-free day trips."
  },
  {
    "WhyChooseheading": "Convenient Location Near Pune",
    "WhyChoosedescription": "Just around 55 km from Pune, Morachi Chincholi is easily accessible by school buses, making it an ideal one-day outing destination for students to experience nature and agriculture close to the city."
  }
]
























    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Morachi Chincholi suitable for a one-day school picnic?',
    answer: 'Yes! Morachi Chincholi is an excellent spot for school picnics with plenty of open space, nature trails, and educational farm activities for children.',
  },
  {
    id: 'FAQ2',
    question: 'What activities are available for school children during the picnic?',
    answer: 'Students can enjoy peacock watching, bullock cart rides, nature walks, farm visits, interactive farming sessions, and traditional games.',
  },
  {
    id: 'FAQ3',
    question: 'Are there safe and kid-friendly facilities at Morachi Chincholi?',
    answer: 'Yes, the area is safe for children, with shaded rest areas, clean washrooms, and staff supervision during activities to ensure child safety.',
  },
  {
    id: 'FAQ4',
    question: 'Can the picnic include educational tours?',
    answer: 'Definitely. Many agro-tourism centers offer guided tours explaining farming practices, local ecology, and conservation efforts suitable for school groups.',
  },
  {
    id: 'FAQ5',
    question: 'Are meals provided during the school picnic?',
    answer: 'Yes, wholesome traditional meals made from fresh farm produce are usually included in the picnic packages, with options for vegetarian and special diets.',
  },
  {
    id: 'FAQ6',
    question: 'How far is Morachi Chincholi from Pune for a day trip?',
    answer: 'It is about 60–65 km from Pune, approximately a 1.5 to 2-hour drive, making it ideal for a one-day school picnic.',
  },
  {
    id: 'FAQ7',
    question: 'Is transportation arranged for school groups?',
    answer: 'Some resorts and centers can help arrange buses or vans for school groups, or you can coordinate your own transport for convenience.',
  },
  {
    id: 'FAQ8',
    question: 'What is the best season to plan a school picnic here?',
    answer: 'The best time is from October to March, when the weather is pleasant and the farm activities are most engaging for children.',
  },
  {
    id: 'FAQ9',
    question: 'Are there any special safety protocols for school picnics?',
    answer: 'Yes, venues maintain strict safety measures including child supervision, first aid availability, and secure boundaries around play and activity areas.',
  },
  {
    id: 'FAQ10',
    question: 'How do I book a one-day school picnic at Morachi Chincholi?',
    answer: 'Contact agro-tourism centers like Anand Krushi Paryatan Kendra directly to check availability, discuss group size, and customize your picnic package.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Ms. Priya Deshpande, School Teacher, Pune',
    feedback: "Our students loved the one-day picnic to Morachi Chincholi! The kids enjoyed every activity and learned a lot about farming and nature. Very well organized.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Suresh Patil, Principal, PCMC',
    feedback: "A perfect location for our school outing. Safe, fun, and educational. The food and facilities were great, and the staff was very supportive throughout the day.",
    rating: 5,
  },
];



























    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One-day School Picnic Near Morachi Chincholi Pune",
  "image": "https://morachichincholi.in/assets/images/school-picnic-morachi-chincholi.jpg",
  "description": "Plan an educational and fun one-day school picnic near Morachi Chincholi Pune with safe locations, agro-tourism activities, bird watching, farm games, interactive workshops, guided nature walks, and lunch facilities.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "520"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/school-picnic"
  }
};



    return (
        <div>
<Helmet>
  <title>One-day School Picnic Near Morachi Chincholi Pune | Educational Farm Outings</title>
  <meta 
    name="description" 
    content="Organize a one-day school picnic near Morachi Chincholi Pune with safe, educational farm activities, bird watching tours, cultural learning, interactive workshops, guided nature walks, and lunch facilities." 
  />
  <meta 
    name="keywords" 
    content="Educational picnic near Morachi Chincholi, Safe school picnic locations near Pune, Fun learning farm activities for students, Nature-based school outings, Bird watching tours for kids, Agro-tourism picnic for schools, Cultural learning trips for students, Farm games for children, Interactive workshops for school groups, School picnic with lunch facility, Outdoor team-building for students, Guided nature walks for schools, Eco-friendly picnic ideas for schools, Budget school trips near Pune, One-day school field trip locations" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onedayschoolpicnic;